function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import DiscretelyTimeVaryingMixin from "../ModelMixins/DiscretelyTimeVaryingMixin";
import { DATE_SECONDS_PRECISION } from "../ModelMixins/TimeVarying";
import DiscretelyTimeVaryingTraits from "../Traits/TraitsClasses/DiscretelyTimeVaryingTraits";
import CommonStrata from "./Definition/CommonStrata";
import CreateModel from "./Definition/CreateModel";
export default class DefaultTimelineModel extends DiscretelyTimeVaryingMixin(CreateModel(DiscretelyTimeVaryingTraits)) {
  get type() {
    return DefaultTimelineModel.type;
  }
  constructor(uniqueId, terria) {
    super(uniqueId, terria);
    const now = JulianDate.now();
    this.setTrait(CommonStrata.defaults, "startTime", JulianDate.toIso8601(JulianDate.addHours(now, -12, new JulianDate()), DATE_SECONDS_PRECISION));
    this.setTrait(CommonStrata.defaults, "stopTime", JulianDate.toIso8601(JulianDate.addHours(now, 12, new JulianDate()), DATE_SECONDS_PRECISION));
  }
  async forceLoadMapItems() {}
  get mapItems() {
    return [];
  }
  get discreteTimes() {
    return undefined;
  }
}
_defineProperty(DefaultTimelineModel, "type", "default-timeline");